import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import {
  liveClassStudentsState,
  selectStudent,
  selectUnselectAllStudents,
} from 'redux/liveClass/students.slices';

import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { ReactComponent as ArrowDown } from '../../../../../../assets/icons/arrow-down.svg';

import '../students.scoped.scss';

const Students: React.FC = () => {
  const { students, selectedStudents } = useAppSelector(liveClassStudentsState);
  const { t } = useTranslation('live_classes');
  const [showSelectedStudents, setShowSelectedStudents] = useState(false);

  const dispatch = useAppDispatch();
  return (
    <>
      <div className="students-list-header flex justify-between">
        <div>
          <h4>{t('Pick student(s)')}</h4>
        </div>
        <div className="number-of-students">
          <p className=" flex justify-end align-center">
            {selectedStudents.length}
            {selectedStudents.length === 1 ? ` ${t('student')} ` : ` ${t('students')} `}
            {t('selected')}
            <ArrowDown
              className={`selected-students-arrow ${showSelectedStudents ? '' : 'rotate'}`}
              onClick={() => setShowSelectedStudents(!showSelectedStudents)}
            />
            <span onClick={() => dispatch(selectUnselectAllStudents())} className="show-selected">
              {selectedStudents.length === students.length ? '-' : '+'}
            </span>
          </p>
        </div>
      </div>
      <div className="students-list-selected margin-x-10px">
        {showSelectedStudents &&
          selectedStudents &&
          selectedStudents.map(obj => {
            const student = students.filter(std => {
              return std.id === obj;
            })[0];
            return (
              <div className="text-left w-100" key={Math.random()}>
                <label htmlFor={`obj_${student.id}`} className="checkbox-square">
                  <input
                    type="checkbox"
                    id={`obj_${student.id}`}
                    checked={true}
                    onChange={() => dispatch(selectStudent(student.id))}
                  />
                  <span>{student?.user?.full_name}</span>
                </label>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default Students;
